import { createPortal } from "react-dom"
import { Popup, useMap } from "react-leaflet"
import { useSelector, useDispatch } from "react-redux"
import { Fragment, useEffect, useState } from "react"
import { $authHost } from "../../http"
import React from "react"
import { useAuth } from "react-oidc-context"
import {
    Typography,
    Box,
    Tabs,
    Tab,
    Button,
    Card,
    CardContent,
    Paper,
    Stack,
    ImageList,
    ImageListItem,
    ImageListItemBar
} from "@mui/material";
import {
    Place as PlaceIcon,
    Info as InfoIcon,
    ElectricalServices as TransformerIcon,
    Share as ShareIcon,
    Save as SaveIcon,
    Cancel as CancelIcon
} from "@mui/icons-material";
import Viewer from "react-viewer";
import { setLayers } from "../../store/reducers/helpersReducer";
import { getRelatedObjects } from "./helpers";
import { addPulseMarker, aimToObject } from "../controls/helpers";
import { pillarIcon } from "../layers/icons"
import RelatedObjectsPanel from "./Common/RelatedObjectsPanel"
import { addNotification } from "../../store/reducers/notificationSlice"
import SpecsTab from "./Common/SpecsTab"
import MountedTab from "./PopupPillar/MountedTab"
import { useMemo } from "react"
const TabPanel = ({ children, value, index }) => {
    return parseInt(value) === parseInt(index) && <Box sx={{ mt: 0.5 }}>{children}</Box>;
};

const types = {
    'transformer': 'Трансформатор',
    'tp': 'ТП',
    'rtp': 'РТП'
};

const tabs = {
    0: 'Фотоальбом',
    1: 'Спецификация',
    2: 'Монтаж',
    3: 'Связанные объекты'
}

const PopupTransformer = ({ mark }) => {
    console.log(mark)
    const dispatch = useDispatch()
    const map = useMap()
    const auth = useAuth()
    const [value, setValue] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [images, setImages] = useState([]);
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [spec, setSpec] = useState(null);
    const [type, setType] = useState(null);

    // Состояние для отслеживания изменений спецификации
    const [pendingSpecChange, setPendingSpecChange] = useState(null);
    const [tempSpec, setTempSpec] = useState(null);

    const { feedingSubstations, pillars, fiders } = useSelector(state => state.state.electricity)
    const specs_new = useSelector(state => state.state.specs_new)
    const specs = useSelector(state => state.state.specs)
    const user = useSelector(state => state.state.user)
    const [mounted, setMounted] = useState(null)

    // Ключи для localStorage
    const STORAGE_KEYS = {
        TAB_INDEX: 'popupTransformer_tabIndex',
        SEARCH_SPEC: 'popupTransformer_searchSpec'
    };

    // Функции для работы с localStorage
    const saveToStorage = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.warn('Ошибка сохранения в localStorage:', error);
        }
    };

    const loadFromStorage = (key, defaultValue = null) => {
        try {
            const stored = localStorage.getItem(key);
            return stored ? JSON.parse(stored) : defaultValue;
        } catch (error) {
            console.warn('Ошибка загрузки из localStorage:', error);
            return defaultValue;
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const materialMapping = {
        '1': 'Дерево',
        '2': 'Железобетон',
        '3': 'Сталь'
    }

    // Инициализация значения таба после загрузки данных
    useEffect(() => {
        // Получаем доступные табы
        const availableTabs = Object.entries(tabs).filter(([key, title]) => {
            if (key == 0 && images.length === 0) return false;
            if (key == 2 && (!mounted || mounted.length === 0)) return false;
            return true;
        });

        if (availableTabs.length === 0) return;

        // Если значение еще не установлено, устанавливаем первый доступный таб
        if (value === null || value === undefined) {
            const firstAvailableTab = parseInt(availableTabs[0][0]);
            setValue(firstAvailableTab);
            return;
        }

        // Проверяем, доступен ли текущий таб
        const isCurrentTabAvailable = availableTabs.some(([key]) => parseInt(key) === parseInt(value));

        // Если текущий таб недоступен, устанавливаем первый доступный
        if (!isCurrentTabAvailable) {
            const firstAvailableTab = parseInt(availableTabs[0][0]);
            setValue(firstAvailableTab);
        }
    }, [images, mounted])

    useEffect(() => {
        // Определяем тип для трансформаторов
        if (mark.type === 'transformer' || mark.type === 'tp' || mark.type === 'rtp') {
            setType('transformers');
        } else {
            setType(mark.type);
        }
    }, [mark])

    // Права на редактирование спецификации
    const canEditSpec = useMemo(() => {
        return user.roles?.includes('editor') || false;
    }, [user]);

    useEffect(() => {
        // Не обновляем spec если есть незавершенные изменения
        if (pendingSpecChange) return;

        if (specs_new && mark.spec && specs_new[mark.spec] && type) {
            if (mark.spec_complect) {
                setSpec(specs_new[mark.spec]?.[Number(mark.spec_complect)]);
            } else {
                setSpec(Object.values(specs_new[mark.spec])[0]);
            }
        } else {
            setSpec(null);
        }
    }, [specs_new, mark, type, pendingSpecChange])

    // Функция для обновления спецификации трансформатора (только локальное изменение)
    const handleSpecChange = (newSpecId) => {
        // Сохраняем исходный spec для возможности отмены (только при первом изменении)
        // Используем null как маркер, что изменения есть (даже если изначально spec не был задан)
        if (pendingSpecChange == null) {
            setPendingSpecChange(mark.spec || null);
        }

        // Обновляем локальное состояние для отображения новой спецификации
        if (specs_new && specs_new[newSpecId] && type) {
            const newSpec = Object.values(specs_new[newSpecId])[0];
            setTempSpec(newSpec);
        }
    };

    // Функция для сохранения изменений спецификации
    const handleSaveSpecChange = async () => {
        // Проверяем наличие изменений: либо есть tempSpec, либо pendingSpecChange установлен
        if (!tempSpec && pendingSpecChange == null) return;

        try {
            // Обновляем спецификацию через новый endpoint
            const response = await $authHost.post(`/apig/gisdb/updatespec`, {
                id: mark.fid,
                type: type,
                spec: tempSpec?.id || mark.spec
            }, {
                headers: {
                    Authorization: `Bearer ${auth.user.access_token}`
                }
            });

            if (response.status >= 200 && response.status < 300 && response.data?.success) {
                // Обновляем mark.spec
                const savedSpecId = tempSpec?.id || mark.spec;
                mark.spec = savedSpecId;

                // Обновляем spec из tempSpec
                if (tempSpec) {
                    setSpec(tempSpec);
                }

                // Сбрасываем состояние изменений
                setPendingSpecChange(null);
                setTempSpec(null);

                // Перезагружаем mounted данные
                if (type) {
                    $authHost.get(`/apig/execution/${type}/${mark.fid}/history`).then(res => {
                        setMounted(res.data.data)
                    }).catch(err => {
                        console.log(`Get mounted for transformer ${mark.fid} error`, err)
                        setMounted(null)
                    })
                }

                dispatch(addNotification({
                    message: 'Спецификация успешно сохранена!',
                    severity: 'success',
                    autoHideDuration: 3000
                }));
            } else {
                const errorMessage = response.data?.error || 'Произошла ошибка при сохранении спецификации.';
                dispatch(addNotification({
                    message: errorMessage,
                    severity: 'error',
                    autoHideDuration: 5000
                }));
            }
        } catch (error) {
            console.error('Ошибка при сохранении спецификации:', error);
            if (error.response) {
                const status = error.response.status;
                const errorMessage = error.response.data?.error || 'Ошибка сервера';
                if (status === 401) {
                    dispatch(addNotification({
                        message: 'Ошибка авторизации. Пожалуйста, перезайдите в систему.',
                        severity: 'error',
                        autoHideDuration: 5000
                    }));
                } else if (status === 403) {
                    dispatch(addNotification({
                        message: 'У вас нет прав для выполнения этого действия.',
                        severity: 'error',
                        autoHideDuration: 5000
                    }));
                } else if (status === 400) {
                    dispatch(addNotification({
                        message: errorMessage,
                        severity: 'error',
                        autoHideDuration: 5000
                    }));
                } else {
                    dispatch(addNotification({
                        message: 'Ошибка сервера. Попробуйте позже.',
                        severity: 'error',
                        autoHideDuration: 5000
                    }));
                }
            } else {
                dispatch(addNotification({
                    message: 'Сервер не отвечает. Проверьте подключение к интернету.',
                    severity: 'error',
                    autoHideDuration: 5000
                }));
            }
        }
    };

    // Функция для отмены изменений спецификации
    const handleCancelSpecChange = () => {
        // Проверяем наличие изменений
        if (pendingSpecChange == null && !tempSpec) return;

        // Восстанавливаем исходную спецификацию
        if (pendingSpecChange != null && specs_new && specs_new[pendingSpecChange] && type) {
            const originalSpec = Object.values(specs_new[pendingSpecChange])[0];
            setSpec(originalSpec);
        } else {
            // Если изначально не было спецификации, просто сбрасываем
            setSpec(null);
        }

        // Сбрасываем состояние изменений
        setPendingSpecChange(null);
        setTempSpec(null);

        dispatch(addNotification({
            message: 'Изменения спецификации отменены',
            severity: 'warning',
            autoHideDuration: 3000
        }));
    };

    useEffect(() => {
        if (!type) return
        $authHost.get(`/apig/execution/${type}/${mark.fid}/history`).then(res => {
            setMounted(res.data.data)
        }).catch(err => {
            console.log(`Get mounted for transformer ${mark.fid} error`, err)
            setMounted(null)
        })
    }, [mark, type, auth])

    const mountedSpecs = useMemo(() => {
        if (!mounted || !specs || !type) return null
        return mounted.map(m => specs[type]?.find(s => s.id === m.spec))
    }, [mounted, specs, type])
    function selectHost(host, layer = null) {
        map.fire('popupclose')
        if (host) {

            // if (window.innerWidth < 768) {
            //     setIsHidden(true)
            // }
            // map.panTo([
            //     host.x_y_coord.split(' ')[1],
            //     host.x_y_coord.split(' ')[0],
            // ], 16, { duration: 1, animate: false })
            if (host.coords) {
                map.flyTo(host.coords, 18, { duration: 1, animate: false })
            } else if (host.bounds) {
                map.flyToBounds(host.bounds, 18, { duration: 1, animate: false })
            } else {
                map.flyTo([
                    host.x_y_coord.split(' ')[1],
                    host.x_y_coord.split(' ')[0],
                ], 16, { duration: 1, animate: false })
            }

            map.eachLayer(function (layer) {
                layer.closeTooltip()
                // layer.closePopup()
            })
            // map.flyTo([
            //     host.x_y_coord.split(' ')[1],
            //     host.x_y_coord.split(' ')[0],
            // ], 16, { duration: 1, animate: false })
            dispatch(setLayers([
                { layer: 'transformers', position: 1 },
                { layer: 'pillars04', position: 1 },
                { layer: 'fider04', position: 1 }
            ]))
            setTimeout(() => {

                map.closePopup()

                map.eachLayer(function (layer) {
                    if (layer.options.data === host.fid) {
                        layer.openTooltip()
                        addPulseMarker(map, layer)
                    }
                })
            }, 500)
        }
    }

    function getRelatedObjects(mark) {
        // const { feedingSubstations, pillars04 } = useSelector(state => state.state.electricity) 

        const relatedObjects = []
        if (mark.ps_id) {
            const fs = feedingSubstations.filter(fs => fs.fid.toString() === mark.ps_id.toString())
            if (fs.length > 0) {
                fs.forEach(fs => {
                    relatedObjects.push(
                        <Box key={`fs_${fs.fid}`} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer', margin: '2px 10px' }} onClick={() => aimToObject(map, fs)}>
                            <svg fill="#000000" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24">
                                <path d="M21.9,19.3l-9-15.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.3-1.1-0.2-1.4,0.3l-9,15.6C2,19.4,2,19.6,2,19.8c0,0.6,0.4,1,1,1h18c0.2,0,0.3,0,0.5-0.1C22,20.4,22.1,19.8,21.9,19.3z"
                                    fill="#96CD93" stroke="#40A438" strokeWidth="2px" opacity="0.9" />
                            </svg>
                            <Typography style={{ color: '#40A438', margin: '0 10px', fontSize: { xs: '0.65rem', sm: '0.75rem' } }}>{fs.name}</Typography>
                        </Box>
                    )
                })
                // relatedObjects.push(...feedingSubstations)
            }
        }


        const p = pillars.filter(p => p.tp_id?.toString() === mark.fid.toString()).filter(f => f)

        if (p.length > 0) {
            p.sort((a, b) => parseInt(a.draft_num) - parseInt(b.draft_num)).forEach(p => {
                const type = p.status
                relatedObjects.push(

                    <div key={`pillar_${p.fid}`} style={{ margin: '2px 10px', verticalAlign: 'middle', textAlign: 'left', cursor: 'pointer' }} onClick={() => aimToObject(map, p)}>
                        {pillarIcon(p.type, p.status, p.material_type, p.supports_count, 14)}
                        <span style={{ color: `var(--${type})`, marginLeft: '10px' }}>{p.name}</span>
                    </div>

                )
            })
        }

        const f = fiders.filter(f => f.tp_id?.toString() === mark.fid.toString()).filter(f => f)
        if (f.length > 0) {
            f.forEach(f => {
                relatedObjects.push(
                    <div key={`fider_${f.id}`} style={{ margin: '2px 10px', verticalAlign: 'middle', textAlign: 'left', cursor: 'pointer' }} onClick={() => aimToObject(map, f)}>
                        <svg fill="#000000" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24">
                            <rect x="0" y="12" width="24" height="6" rx="5" fill={f.color ? `rgb( ${f.color.split(',').slice(0, 3).join(' ')} )` : 'black'} />
                        </svg>
                        <span style={{ color: f.color ? `rgb( ${f.color.split(',').slice(0, 3).join(' ')} )` : 'black', marginLeft: '10px' }}>{f.layer}</span>
                    </div>
                )
            })
        }

        return relatedObjects
    }

    function getContent() {
        return (
            <Paper elevation={0} sx={{ bgcolor: 'background.paper' }}>
                <Tabs
                    value={value !== null && value !== undefined ? value : false}
                    onChange={(_event, newValue) => setValue(newValue)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    sx={{
                        minHeight: { xs: 20, sm: 30 },
                        '& .MuiTab-root': {
                            minHeight: { xs: 20, sm: 30 },
                            py: { xs: 0.2, sm: 0.5 },
                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                            fontWeight: 600
                        }
                    }}
                >
                    {Object.entries(tabs).map(([key, title]) => {
                        if (key == 0 && images.length === 0) return null
                        if (key == 2 && (!mounted || mounted.length === 0)) return null
                        return <Tab key={key} value={parseInt(key)} label={title} />
                    })}
                </Tabs>

                <TabPanel value={value} index={0}>
                    <ImageList cols={3} style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                        {images.map((image, i) => {
                            return (
                                <ImageListItem key={image['d:propstat']['d:prop']['oc:fileid']}>
                                    <img
                                        src={`http://gis.komoks.ru/apig/share/image_preview?id=${image['d:propstat']['d:prop']['oc:fileid']}`}
                                        alt={image['d:propstat']['d:prop']['d:displayname']}
                                        loading="lazy"
                                        onClick={() => {
                                            setActiveIndex(i);
                                            setVisible(true);
                                        }}
                                    />
                                    <ImageListItemBar
                                        title={image['d:propstat']['d:prop']['d:displayname']}
                                    />
                                </ImageListItem>
                            )
                        })}
                    </ImageList>
                    <Viewer
                        visible={visible}
                        onClose={() => setVisible(false)}
                        images={images.map(image => ({
                            src: `http://gis.komoks.ru/apig/share/image_full?tpid=${mark.tp_id}&pillarid=${mark.fid}&imageid=${image['d:propstat']['d:prop']['oc:fileid']}`,
                            alt: image['d:propstat']['d:prop']['d:displayname'],
                            downloadUrl: `http://gis.komoks.ru/apig/share/image_full?tpid=${mark.tp_id}&pillarid=${mark.fid}&imageid=${image['d:propstat']['d:prop']['oc:fileid']}`
                        }))}
                        activeIndex={activeIndex}
                        zIndex={9999}
                        downloadable={true}
                        scalable={true}
                        rotatable={true}
                        zoomable={true}
                        drag={true}
                        downloadInNewWindow={true}
                    />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <SpecsTab
                        spec={tempSpec || spec}
                        saveToStorage={saveToStorage}
                        STORAGE_KEYS={STORAGE_KEYS}
                        darkMode={false}
                        specs={specs}
                        type={type}
                        mark={mark}
                        onSpecChange={handleSpecChange}
                        canEdit={canEditSpec}
                    />
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <MountedTab
                        mark={mark}
                        mounted={mounted}
                        mountedSpecs={mountedSpecs}
                        spec={spec}
                        darkMode={false}
                    />
                </TabPanel>

                <TabPanel value={value} index={3}>
                    <div style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }}>
                        {/* {getRelatedObjects(mark)} */}
                        <RelatedObjectsPanel mark={mark} darkMode={false} />
                    </div>
                </TabPanel>
            </Paper>
        );
    }

    console.log('tuta')
    return (
        createPortal(
            <Popup
                position={mark.coords}
                key={`transformer_${mark.fid}`}
                maxWidth={window.innerWidth < 768 ? 350 : 600}
                autoClose={false}
                offset={[0, -8]}
                className="transformer-popup"
                eventHandlers={{
                    add: (p) => {
                        $authHost.get(`/apig/state/transformers/images_list?tpid=${mark.fid}`).then(res => {
                            if (res) {
                                setImages(res.data)
                            }
                        }).catch(err => {
                            setImages([])
                            console.log(err)
                        })
                    }
                }}
            >
                <Paper elevation={0} sx={{ m: 0, p: 0, bgcolor: 'transparent' }}>
                    {/* Заголовок */}
                    <Card variant="outlined" sx={{ mb: 0.5 }}>
                        <CardContent sx={{ p: 0.2, textAlign: 'center', '&:last-child': { pb: 0.2 } }}>
                            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                <Typography variant="subtitle2" fontWeight="600" color="primary.main" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                                    {types[mark.type] || 'Трансформатор'}: {mark.name}
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>

                    {/* Основной контент */}
                    <Box sx={{ mb: 0.5 }}>
                        {getContent()}
                    </Box>

                    {/* Кнопки действий */}
                    <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center" p={0.5} flexWrap="wrap">
                        <Stack direction="row" gap={1} flexWrap="wrap">
                            {mark.coords && (
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<PlaceIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        window.open(`https://yandex.ru/maps/?whatshere[point]=${mark.coords[1]},${mark.coords[0]}&whatshere[zoom]=17`);
                                    }}
                                    sx={{
                                        minWidth: 'auto',
                                        px: { xs: 1, sm: 1.5 },
                                        py: { xs: 0.2, sm: 0.3 },
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}
                                >
                                    Карта
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<ShareIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    console.log(mark)
                                    const base64 = btoa(JSON.stringify({
                                        type: mark.type,
                                        id: mark.fid,
                                    }))
                                    navigator.clipboard.writeText(`${window.location.origin}/an?view=${encodeURIComponent(base64)}`)
                                    dispatch(addNotification({
                                        message: 'Ссылка на объект скопирована в буфер обмена',
                                        severity: 'success',
                                        autoHideDuration: 3000
                                    }))
                                }}
                                sx={{
                                    minWidth: 'auto',
                                    px: { xs: 1, sm: 1.5 },
                                    py: { xs: 0.2, sm: 0.3 },
                                    fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                }}
                            >
                                Поделиться
                            </Button>
                        </Stack>

                        {/* Кнопки сохранения изменений спецификации */}
                        {(pendingSpecChange != null || tempSpec) && (
                            <Stack direction="row" spacing={1} justifyContent="flex-end" flexWrap="wrap">
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    startIcon={<SaveIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSaveSpecChange();
                                    }}
                                    sx={{
                                        minWidth: 'auto',
                                        px: { xs: 1, sm: 1.5 },
                                        py: { xs: 0.2, sm: 0.3 },
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}
                                >
                                    Сохранить
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    size="small"
                                    startIcon={<CancelIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleCancelSpecChange();
                                    }}
                                    sx={{
                                        minWidth: 'auto',
                                        px: { xs: 1, sm: 1.5 },
                                        py: { xs: 0.2, sm: 0.3 },
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}
                                >
                                    Отмена
                                </Button>
                            </Stack>
                        )}
                    </Stack>
                </Paper>
            </Popup>,
            document.getElementsByClassName('leaflet-pane leaflet-popup-pane')[0]
        )
    )


}

export default PopupTransformer